// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__TyayS","ellipsis":"styles_ellipsis__LzkIE","text2AndMoreLines":"styles_text2AndMoreLines__L5Z9G","tooltipTrigger":"styles_tooltipTrigger__uaXDq"};